import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { useNavigate } from 'react-router'

export const ShiftHeader = () => {
  const { t } = useTranslate()
  const navigate = useNavigate()
  const title = t('Shifts', 'Shifts')
  const breadcrumbs = [
    { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
    {
      label: title,
    },
  ]

  return (
    <Header
      title={title}
      position='relative'
      breadcrumbs={breadcrumbs}
      rightRenderOption={
        <Button
          color='primary'
          variant='contained'
          sx={{ flex: 'none' }}
          onClick={() => navigate(`0`)}
        >
          {t('createShift', 'Create shift')}
        </Button>
      }
    />
  )
}
